import { Observable } from 'rxjs';
import { apiClient } from '~admin/client';
import { EventTranslationRequest } from '~client/model/admin/event-translation-request';
import { ResponseEntity } from '~client/model/response-entity';

/**
 * Adds translations to an existing Event Profile
 * @param request
 */
export const performAddEventProfileTranslations = (
  request: EventTranslationRequest,
): Observable<ResponseEntity> => apiClient.eventAdminController.addEventTranslations$(request);



// WEBPACK FOOTER //
// ./interactor/event/perform-add-event-profile-translations.ts